<script setup lang="ts">
import type { ICustomField } from '@nova/core';

/**
 * Label component for custom fields.
 * Displays field label with optional required indicator.
 */
interface Props {
  field: ICustomField;
  required?: boolean;
  htmlFor?: string;
}

withDefaults(defineProps<Props>(), {
  required: false
});
</script>

<template>
  <label class="custom-field-label" :for="htmlFor">
    <span class="custom-field-label__text">{{ field.label }}</span>
    <span v-if="required" class="custom-field-label__required text--color-text-error">*</span>
    <slot name="append"></slot>
  </label>
</template>

<style scoped lang="scss">
.custom-field-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  &__text {
    font-weight: 500;
  }

  &__required {
    margin-left: 4px;
  }
}
</style>
